module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade"
  }, [_c('v-dialog', {
    attrs: {
      "value": _vm.value,
      "width": "400"
    },
    on: {
      "input": function($event) {
        return _vm.$emit('input')
      }
    }
  }, [_c('v-layout', [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', [_c('v-toolbar', {
    staticClass: "elevation-2",
    attrs: {
      "dense": ""
    }
  }, [_c('v-spacer'), _vm._v(" "), _c('v-toolbar-title', [_vm._v("Create Password")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    }
  }, [_c('v-icon', {
    on: {
      "click": _vm.closeModal
    }
  }, [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-card-text', [_c('v-alert', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errorMessage && _vm.errorMessage !== null),
      expression: "errorMessage && errorMessage !== null"
    }],
    attrs: {
      "type": "error"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.errorMessage) + "\n          ")]), _vm._v(" "), _c('form', [_c('v-container', {
    staticClass: "remove-padding",
    attrs: {
      "container--fluid": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm12": ""
    }
  }, [_c('label', {
    staticClass: "mt-3"
  }, [_vm._v("Generate a strong password")]), _vm._v(" "), _c('div', {
    staticClass: "d-flex flex-row justify-space-between"
  }, [_c('span', {
    staticStyle: {
      "font-weight": "500",
      "padding-top": "6px"
    }
  }, [_vm._v(_vm._s(_vm.generatedPass))]), _vm._v(" "), _c('div', [_c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        return _vm.copyPass()
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("mdi-content-copy")])], 1), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        return _vm.generatePass()
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("mdi-reload")])], 1)], 1)]), _vm._v(" "), _c('label', {
    staticClass: "mt-3"
  }, [_vm._v("Set Password")]), _vm._v(" "), _c('div', {
    staticClass: "d-flex flex-row"
  }, [_c('v-text-field', {
    staticClass: "input-group--focused mt-0 pt-0",
    attrs: {
      "error-messages": _vm.passwordError,
      "type": "text",
      "autocomplete": "new-password",
      "name": "new-password",
      "color": "#1687c0",
      "label": ""
    },
    on: {
      "input": function($event) {
        return _vm.$v.user.newPassword.$touch()
      },
      "blur": function($event) {
        return _vm.$v.user.newPassword.$touch()
      },
      "click:append": function($event) {
        _vm.show.password = !_vm.show.password
      }
    },
    model: {
      value: (_vm.user.newPassword),
      callback: function($$v) {
        _vm.$set(_vm.user, "newPassword", $$v)
      },
      expression: "user.newPassword"
    }
  })], 1)])], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "text": ""
    },
    on: {
      "click": _vm.closeModal
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": "",
      "color": "secondary",
      "disabled": _vm.$v.user.$invalid
    },
    on: {
      "click": _vm.changePassword
    }
  }, [_vm._v("Save")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "id": "copy-pass"
    },
    domProps: {
      "value": _vm.generatedPass
    }
  }), _vm._v(" "), _c('loading', {
    attrs: {
      "active": _vm.isLoading,
      "can-cancel": false,
      "is-full-page": true,
      "loader": "bars",
      "background-color": "#000",
      "color": "secondary",
      "width.number": "180",
      "height.number": "180"
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b731b9e6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Influencer/JoinCommunity/InfOnboardPasswordModal.vue
// module id = 2275
// module chunks = 0